(() => {
  'use strict';

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function syncRadioState(root = document) {
    qsa("input[type='radio']", root).forEach((input) => {
      const label = input.id ? root.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      if (!label) return;
      label.toggleAttribute('data-selected', input.checked);
      if (input.checked) label.setAttribute('aria-current', 'true');
      else label.removeAttribute('aria-current');
    });
  }

  function enhanceInputs(root = document) {
    qsa('input, textarea, select', root).forEach((field) => {
      const update = () => {
        const filled = field.type === 'checkbox' || field.type === 'radio' ? field.checked : String(field.value || '').trim().length > 0;
        field.toggleAttribute('data-filled', filled);
        field.closest('.field, .nl-personalization-field, .product-form__input')?.toggleAttribute('data-filled', filled);
      };
      field.addEventListener('input', update, { passive: true });
      field.addEventListener('change', () => { update(); syncRadioState(field.form || document); });
      update();
    });
    syncRadioState(root);
  }

  function insertCheckoutNote(root = document) {
    const selectors = [
      "button[name='checkout']",
      "input[name='checkout']",
      "a[href*='/checkout']",
      '.cart__checkout-button',
      '#CartDrawer-Checkout'
    ];
    selectors.forEach((selector) => {
      qsa(selector, root).forEach((button) => {
        const host = button.parentElement;
        if (!host || host.querySelector('.nl-v8-checkout-note')) return;
        const note = document.createElement('p');
        note.className = 'nl-v8-checkout-note';
        note.textContent = 'Kitame žingsnyje įvesite pristatymo adresą, pasirinksite pristatymo būdą ir tik tada apmokėsite.';
        host.appendChild(note);
      });
    });
  }

  function buildStickyAddToCart() {
    if (!document.body.classList.contains('nl-v8-page-product')) return;
    if (document.querySelector('.nl-v8-sticky-atc')) return;

    const form = qs("form[action*='/cart/add']");
    const mainButton = form && qs("button[type='submit'][name='add'], button[type='submit']", form);
    if (!form || !mainButton) return;

    const bar = document.createElement('div');
    bar.className = 'nl-v8-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Greitas prekės pridėjimas');

    const meta = document.createElement('div');
    meta.className = 'nl-v8-sticky-atc__meta';
    const title = document.createElement('span');
    title.className = 'nl-v8-sticky-atc__title';
    title.textContent = (qs('.product__title, h1', document)?.textContent || '').trim();
    const price = document.createElement('span');
    price.className = 'nl-v8-sticky-atc__price';
    meta.append(title, price);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'nl-v8-sticky-atc__button';

    const update = () => {
      const currentPrice = qs('.product__info-container .price, .product__info-wrapper .price, .product .price');
      price.textContent = (currentPrice?.textContent || '').replace(/\s+/g, ' ').trim();
      const mainText = qs('span', mainButton)?.textContent || mainButton.textContent || 'Įdėti į krepšelį';
      button.textContent = mainText.replace(/\s+/g, ' ').trim();
      button.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
    };

    button.addEventListener('click', () => {
      const firstInvalid = qsa('input, textarea, select', form).find((field) => typeof field.checkValidity === 'function' && !field.checkValidity());
      if (firstInvalid) {
        firstInvalid.reportValidity();
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalid.focus({ preventScroll: true });
        return;
      }
      mainButton.click();
    });

    bar.append(meta, button);
    document.body.appendChild(bar);
    update();

    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('nl-v8-sticky-open', visible);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        setVisible(!entry.isIntersecting && window.matchMedia('(max-width: 749px)').matches);
      }, { threshold: .1 });
      observer.observe(mainButton);
    } else {
      setVisible(window.matchMedia('(max-width: 749px)').matches);
    }

    const mutation = new MutationObserver(update);
    mutation.observe(form.closest('product-info') || form.parentElement, { subtree: true, childList: true, characterData: true, attributes: true });
    window.addEventListener('resize', () => {
      if (!window.matchMedia('(max-width: 749px)').matches) setVisible(false);
    }, { passive: true });
  }

  function observeDynamicContent() {
    const observer = new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        enhanceInputs(node);
        insertCheckoutNote(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    document.documentElement.classList.add('nl-v8-ready');
    enhanceInputs();
    insertCheckoutNote();
    buildStickyAddToCart();
    observeDynamicContent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
